var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.313 22.99c4.624 2.745 6.936 4.117 7.341 6.075a4.6 4.6 0 0 1 0 1.87c-.405 1.958-2.717 3.33-7.342 6.075l-15.75 9.346c-4.624 2.744-6.936 4.116-8.789 3.497a4.35 4.35 0 0 1-1.575-.934c-1.448-1.34-1.448-4.084-1.448-9.573V20.654c0-5.489 0-8.233 1.448-9.572.455-.422.992-.74 1.575-.935 1.853-.62 4.165.753 8.79 3.497z"
  })));
};
export default SvgPlay;